import React from 'react';
import { Button } from '@/components/ui/button';
import { X } from '@/components/icons';

interface CloseButtonProps {
  onClick?: () => void;
  ariaLabel?: string;
  className?: string;
  size?: React.ComponentProps<typeof Button>['size'];
  variant?: React.ComponentProps<typeof Button>['variant'];
  iconClassName?: string;
}

const CloseButton: React.FC<CloseButtonProps> = ({ onClick, ariaLabel = 'Cerrar', className, size = 'icon', variant = 'default', iconClassName = 'h-5 w-5' }) => (
  <Button size={size} variant={variant} onClick={onClick} aria-label={ariaLabel} className={className}>
    <X className={iconClassName} />
    <span className="sr-only">{ariaLabel}</span>
  </Button>
);

export const CloseIcon: React.FC<React.SVGProps<SVGSVGElement> & { className?: string }> = ({ className, ...props }) => (
  <X className={className} {...props} />
);

export default CloseButton;
